module.exports = __webpack_public_path__ + "img/gobuy.b1ce1db6.png";